export default "__VITE_ASSET__B$KOjCah__"